import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import ScalarMetric from '../ScalarMetric';

export default function FeedbackMomentsCompletedMetric({
	data,
}: {
	data: graphql.AnalyticsFeedbackMomentsCompleted;
}) {
	const { t } = useTranslation();

	const percentage = Math.round(data.percentage * 100);

	return (
		<ScalarMetric
			loading={false}
			title={t('dashboard.metrics.feedbackMomentsCompleted.title')}
			value={`${percentage}`}
			quantity="%"
			byline={t('dashboard.metrics.feedbackMomentsCompleted.byline', {
				completed: data.completed,
				total: data.total,
			})}
		/>
	);
}
